// export enum Sizes {
//     Small,
//     Large
// };

// export const optionRegistration = [
//   { value: "select", label: "Selecciona tu categoria" },
//   {
//     value: "Professional",
//     label: "Membresia 2023",
//   },
// ];

export const optionRegistration = [
  { value: "select", label: "Selecciona tu categoria" },
  // {
  //   value: "Expositor",
  //   label: "Expositor / Presenter",
  // },
  // {
  //   value: "Professional",
  //   label: "Profesional  / Professional",
  // },
  // { value: "Student", label: "Estudiante / Student" },
  { value: "Member", label: "Miembro SEBOL / SEBOL Member" },
]

export const optionSubscription = [
  { value: "select", label: "Selecciona tu categoria" },

  {
    value: "Expositor",
    label: "Expositor / Presenter",
  },

  // {
  //   value: "Professional",
  //   label: "Profesional   / Professional ",
  // },

  // { value: "Student", label: "Estudiante / Student" },
]

export const optionsDegree = [
  {
    label: "Doctorado (Ph.D.)",
    value: "PhD",
  },
  {
    label: "Maestria (Master)",
    value: "Master",
  },
  {
    label: "Licenciatura (Bachelor)",
    value: "Bachelor",
  },
  {
    label: "No aplica (NA)",
    value: "NA",
  },
]

export const optionsOccupation = [
  {
    label: "Profesional (Professional)",
    value: "Profesional",
  },
  {
    label: "Investigación (Research)",
    value: "Investigación",
  },
  {
    label: "Docencia (Teaching)",
    value: "Docente",
  },
  {
    label: "Estudiante universitario (College student)",
    value: "Estudiante",
  },
  {
    label: "No aplica (NA)",
    value: "NA",
  },
]

export const optionsAffiliation = [
  {
    label: "U.A. Juan Misael Saracho",
    value: "UAJMS",
  },
  {
    label: "BID",
    value: "BID",
  },
  {
    label: "CAF",
    value: "CAF",
  },
  {
    label: "UCB",
    value: "UCB",
  },
  {
    label: "IISEC",
    value: "IISEC",
  },
  {
    label: "FES",
    value: "FES",
  },
  {
    label: "Swisscontact",
    value: "Swisscontact",
  },
  {
    label: "INESAD",
    value: "INESAD",
  },
  {
    label: "ABCE",
    value: "ABCE",
  },
  {
    label: "UPB",
    value: "UPB",
  },
  {
    label: "Embajada Británica",
    value: "UKEMB",
  },
  {
    label: "Gobernación de Tarija",
    value: "TJAGOB",
  },
  {
    label: "Alcaldia de Tarija",
    value: "TJAMUN",
  },
  {
    label: "Sector Privado",
    value: "PRIV",
  },
  {
    label: "Otro",
    value: "other",
  },
]
